<template>
  <div class="section-heading" :class="{ centered }">
    <span v-if="eyebrow" class="eyebrow">{{ eyebrow }}</span>
    <h2>{{ title }}</h2>
    <p v-if="text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'SectionHeading',
  props: {
    eyebrow: String,
    title: { type: String, required: true },
    text: String,
    centered: Boolean
  }
}
</script>